export default "__VITE_ASSET__4uoyj4GA__"